<script>
import SideMenuItem from '../side-menu-item';
import Config       from '../../../../libs/config';

export default {
  name  : 'side-menu-item-announcement-list',
  mixins: [SideMenuItem],
  data  : function() {
    const link = new URL('announcement/', Config.SERVICE_LINK.ATCOSME.SP.URL).href;
    return {
      label    : 'お知らせ一覧へ',
      link     : link,
      analytics: { label: 'side_menu_item_announcement_list' },
      class    : 'global-navi-link-announcement-list',
    };
  },
};
</script>
